import { render } from "./ProductSectionComponent.vue?vue&type=template&id=736df58c"
import script from "./ProductSectionComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productSections/ProductSectionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "736df58c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('736df58c', __exports__)) {
    api.reload('736df58c', __exports__)
  }
  
  module.hot.accept("./ProductSectionComponent.vue?vue&type=template&id=736df58c", () => {
    api.rerender('736df58c', render)
  })

}


export default __exports__